import axios from "axios";
import config from "../../../config";

const baseUrl = config.baseUrl;

const axiosInstance = axios.create({
  baseURL: baseUrl,
});

const dataDashboardDetalle = {
  getDataDahboardDetalle: async () => {
    try {
      const response = await axiosInstance.get('/api/detalleDashboard');
      return response.data;
    } catch (error) {
      console.error('Error al obtener datos del detalle:', error);
      throw error;
    }
  },
};

export default dataDashboardDetalle;
